import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';
import { UserModalComponent } from "./modals/user.modal.component";


@Component({
    templateUrl: './users.component.html',
    styleUrls: [ './users.component.scss' ],
})
export class UsersComponent {
  @ViewChild('userModal') public userModal: UserModalComponent;

  public isLoading:boolean = true;
  public users: any;
  public pager: any = {
    'total': 0, 
    'perPage': environment.itemsPerPage, 
    'page': 1
  };

  public batchActions = [
    { 
      name: 'Edit', 
      type: 'icon', 
      icon: 'fa fa-edit', 
      action: (event) => { this.edit(event) } 
    },
    { 
      name: 'Delete', 
      type: 'icon', 
      icon: 'fa fa-remove', 
      action: (event) => { this.delete(event) } 
    },
  ];

  public columns:Array<any> = [
    {title: 'Nazwa użytkownika', name: 'username', image: 'avatar'},
    {title: 'E-mail', name: 'email'},
    {title: 'Imię', name: 'firstname'},
    {title: 'Nazwisko', name: 'lastname'},
    {title: 'Aktywność', name: 'is_enabled', type: 'boolean'},
    {title: 'Edit', name: 'batch_actions', actions: this.batchActions },
  ];

  constructor(private http: HttpService ) {
    this.loadUsers({page: 1});
    this.users = [];
  }

  public actions:Array<any> = [
    { title: 'Add new', class: 'primary', action: () => this.userModal.show(false) }
  ];

  public loadUsers(event) {
    let page = event.page;
    page = page ? page : 1;

    this.isLoading = true;
    let offset = (page-1)*this.pager.perPage;
    this.http.get(environment.backendUrl+'api/user/list/'+offset+'/'+this.pager.perPage)
           .subscribe(
                data => {
                  this.users = data.json().data;
                  this.pager.total = data.json().count;
                  this.isLoading = false;
                },
                error => setTimeout(this.loadUsers, 5000)
           );

  }

  public delete(event) {
    let id = event.target.parentNode.getAttribute('id');
    this.isLoading = true;

    this.http.delete(environment.backendUrl+'api/user/'+id)
           .subscribe(
                data => {   
                  this.isLoading = false;
                  this.loadUsers({ page: 1 })
                },
                error => setTimeout(this.loadUsers, 5000)
           );
  }

  public refreshList(event) {
    this.loadUsers(1)
  }

  public tableChanged(page=1) {
    this.loadUsers(page);
  }

  public edit(event) {
    let id = event.target.parentNode.getAttribute('id');

    this.http
      .get(environment.backendUrl + 'api/user/'+id, '')
      .subscribe(res => {
        this.userModal.show(res.json());
      });
  }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/users/users.component.ts